import { render, staticRenderFns } from "./LimitsComponent.vue?vue&type=template&id=522f6400"
import script from "./LimitsComponent.vue?vue&type=script&lang=js"
export * from "./LimitsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports